import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { ApiVisa, Core2Config, PagingResponseModel } from '../../shared';
import { EntityEventContainerModel } from '../../../../../../models/aggregates/erp/entity/entity-event-container.model';
import { Observable } from 'rxjs';
import { MerchantEventCriteriaModelQuery, MerchantEventQueryCriteriaClass } from '../../../criteria/pgw/merchant-event-criteria.model';

@Injectable({providedIn: 'root'})
export class MerchantEventService extends BaseApiTemplateService<EntityEventContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'entity/events';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'entity/events';
    this.httpClient = http;
  }

  getMerchantEventByCriteria(
    visa: ApiVisa,
    criteria?: MerchantEventQueryCriteriaClass
  ): Observable<PagingResponseModel<EntityEventContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const buildMerchantCriteriaCriteria = new MerchantEventCriteriaModelQuery(criteria);
    console.log("query", buildMerchantCriteriaCriteria.query);
    return this.httpClient.get<PagingResponseModel<EntityEventContainerModel>>(
      this.apiUrl + "/query?" + buildMerchantCriteriaCriteria.query,
      this.getHttpHeader(visa)
    );
  }
}
